export default "__VITE_ASSET__7bd156ae__"